import React from 'react';
import { browserHistory } from 'react-router';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import FlatButton from '@agora/agora-common/Button';
import Snackbar from '@material-ui/core/Snackbar';
import Grid from '@material-ui/core/Grid';
import { withStyles, withTheme } from '@agora/agora-common';
import * as colours from '../../../styles/colours';
import ContentHolder from '../Common/ContentHolder';
import FormSection from '../Common/FormSection';
import './login.css';

const styles = theme => ({
  container: {
    backgroundColor: colours.pageBackground,
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  },
  content: {
    height: '100%',
  },
  login: {
    color: theme.palette.primary.main,
    fontSize: '13.5px',
    fontWeight: 500,
    textDecoration: 'unset',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    const redirectTo = this.props.redirect;
    this.state = {
      username: '',
      redirect: redirectTo,
      snackbarOpen: !!this.props.statusText,
    };
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(window.location.href);
    if (!searchParams.size && !!this.state.redirect?.length) {
      browserHistory.push(this.state.redirect);
    } else if (localStorage.getItem('token')) {
      browserHistory.push('/Markets');
    }
    this.props.callback(this.state.redirect, this.props.environment);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.statusText
      && this.props.statusText !== prevProps.statusText
    ) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ snackbarOpen: true });
    }
  }

  render() {
    return (
      <ContentHolder>
        <Grid
          container
          alignItems="center"
          justifyContent="center"
          classes={{ container: this.props.classes.content }}
        >
          <Grid item xs={11} md={4}>
            <h1>{this.props.title}</h1>
            <form style={{ paddingTop: '1em' }}>
              <FormSection>
                <TextField
                  placeholder="Email"
                  fullWidth
                  value={this.state.username}
                  onChange={event =>
                    this.setState({ username: event.target.value })
                  }
                />
              </FormSection>
              <div style={{ paddingTop: '2em' }}>
                <FlatButton
                  type="submit"
                  disabled={this.props.isAuthenticating}
                  fullWidth
                  onClick={e => {
                    e.preventDefault();
                    this.props.login(
                      this.state.username,
                      this.state.redirect,
                      this.props.environment,
                    );
                  }}
                >
                  Continue
                </FlatButton>
              </div>
            </form>
          </Grid>
        </Grid>
        <Snackbar
          open={this.state.snackbarOpen}
          message={this.props.statusText}
          onClose={() => this.setState({ snackbarOpen: false })}
        />
      </ContentHolder>
    );
  }
}

LoginForm.propTypes = {
  environment: PropTypes.string.isRequired,
  statusText: PropTypes.string,
  login: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  redirect: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

LoginForm.defaultProps = {
  redirect: '/',
  statusText: '',
};

export default withStyles(styles)(withTheme(LoginForm));
